/* 
  File: ../src/pages/stb/StbAnzeigeVerwaltung.js
  Modul: Stellenanzeigen-Verwaltung (Arbeitgebersicht)
*/

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";

const StbAnzeigeVerwaltung = () => {
  const [anzeigen, setAnzeigen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hinweis, setHinweis] = useState("");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/stb/anzeigen/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
      .then((res) => {
        if (res.data.anzeigen?.length === 0) {
          setHinweis(res.data.message);
        } else {
          setAnzeigen(res.data.anzeigen);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fehler beim Laden der Anzeigen:", err);
        setError("Fehler beim Laden der Anzeigen.");
        setLoading(false);
      });
  }, []);

  const handlePause = async (id) => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/stb/anzeigen/${id}/pause`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      setAnzeigen((prev) =>
        prev.map((a) => (a.id === id ? { ...a, status: "paused" } : a))
      );
    } catch (err) {
      console.error("Fehler beim Pausieren:", err);
      alert("Anzeige konnte nicht pausiert werden.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Anzeige wirklich löschen?")) {
      try {
        await axios.delete(`${config.API_BASE_URL}/api/stb/anzeigen/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });
        setAnzeigen((prev) => prev.filter((a) => a.id !== id));
      } catch (err) {
        console.error("Fehler beim Löschen:", err);
        alert("Anzeige konnte nicht gelöscht werden.");
      }
    }
  };

  const handleEdit = (id) => navigate(`/dashboard/stb/edit/${id}`);
  const handleStats = (id) => navigate(`/dashboard/stb/statistik/${id}`);
  const handleKnowledge = (id) => navigate(`/dashboard/stb/wissensdatenbank/${id}`);
  const handlePreview = (id) => navigate(`/stb/preview/${id}`);

  if (loading) return <div className="text-white text-center">Lade Anzeigen...</div>;
  if (error) return <div className="text-white text-center">{error}</div>;

  return (
    <div className="min-h-screen p-5 text-white">
      <h1 className="text-3xl font-bold mb-6">Meine Stellenanzeigen</h1>

      {hinweis && (
        <div className="text-center text-white text-lg mt-10">
          {hinweis}
          <button
            onClick={() => navigate("/dashboard/stb/edit/new")}
            className="ml-4 px-4 py-2 bg-teal-500 rounded hover:bg-teal-600"
          >
            Neue Anzeige anlegen
          </button>
        </div>
      )}

      {!hinweis && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {anzeigen.map((a) => (
            <div key={a.id} className="bg-gray-900 rounded-lg p-5 shadow-md hover:shadow-xl transition">
              <div className="flex justify-between items-center mb-3">
                <h2 className="text-xl font-bold">{a.title}</h2>
                <span className={`text-xs font-semibold px-2 py-1 rounded ${a.status === "active" ? "bg-green-600" : a.status === "paused" ? "bg-yellow-500" : "bg-gray-500"}`}>
                  {a.status.toUpperCase()}
                </span>
              </div>
              {a.logo_path && (
                <img src={`${config.API_BASE_URL}${a.logo_path}`} alt="Logo" className="h-16 w-auto mb-3" />
              )}
              <p className="text-sm text-gray-300 mb-1"><strong>Region:</strong> {a.region}</p>
              <p className="text-sm text-gray-300 mb-1"><strong>Arbeitsform:</strong> {a.arbeitsform}</p>
              <p className="text-sm text-gray-300 mb-1"><strong>Sprachniveau:</strong> {a.sprachniveau}</p>
              <p className="text-sm text-gray-300 mb-1"><strong>Gehalt:</strong> {a.gehalt} €</p>
              <p className="text-sm text-gray-300 mb-1"><strong>Onboarding-Prämie:</strong> {a.onboarding} €</p>
              <p className="text-sm text-gray-300 mb-1"><strong>Unterkunft:</strong> {a.wohnung}</p>
              <p className="text-sm text-gray-300 mb-2"><strong>Einsatzort:</strong> {a.einsatzort_address}</p>
              <p className="text-sm text-gray-400 italic line-clamp-3 mb-2">{a.description}</p>

              <div className="flex flex-wrap gap-2 mt-3">
                <button onClick={() => handlePreview(a.id)} className="bg-white text-black px-3 py-1 rounded">Vorschau</button>
                <button onClick={() => handleEdit(a.id)} className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded">Bearbeiten</button>
                <button onClick={() => handlePause(a.id)} className="bg-yellow-500 hover:bg-yellow-600 text-black px-3 py-1 rounded">Pausieren</button>
                <button onClick={() => handleDelete(a.id)} className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded">Löschen</button>
                <button onClick={() => handleStats(a.id)} className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1 rounded">Statistik</button>
                <button onClick={() => handleKnowledge(a.id)} className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded">Wissensdatenbank</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StbAnzeigeVerwaltung;
